import React from 'react'

interface ButtonProps {
  button: {
    fields?: {
      url?: string
      target?: string
      title?: string
      theme?: string
    }
  }
  className?: string
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
}

const Button = ({ button, className = '', onClick }: ButtonProps) => {
  if (!button?.fields) return null

  const { url, target, title, theme = 'primary' } = button.fields

  // Build dynamic classes: 'button button--theme'
  const buttonClasses = `button button--${theme}`

  // Combine with any additional className prop
  const finalClasses = [buttonClasses, className].filter(Boolean).join(' ')

  return (
    <a href={url} target={target} title={title} className={finalClasses} onClick={onClick}>
      {title}
    </a>
  )
}

export default Button
